import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/FilterConditionItem/FilterConditionItem.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6,
    _templateObject7;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
import { Button as DefaultButton } from '@gmini/ui-kit';
import { Popper as DefaultPopper } from '@mui/material';
export var Button = styled(DefaultButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: inherit;\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var filled = _ref.filled;
  return filled && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      font-weight: 500;\n      background: #ffffff1a;\n      line-height: 16px;\n      font-size: 13px;\n\n      && path {\n        fill: rgba(255, 255, 255, 0.3);\n      }\n    "])));
}, function (_ref2) {
  var selected = _ref2.selected;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), selected && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      background: rgba(0, 10, 87, 0.12);\n    "]))));
}, function (_ref3) {
  var error = _ref3.error;
  return error && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      color: rgba(217, 87, 94, 0.7);\n      background: rgba(217, 87, 94, 0.22);\n\n      & svg path {\n        fill: rgba(217, 87, 94, 0.3);\n      }\n    "])));
});
export var Popper = styled(DefaultPopper)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  z-index: 10000;\n  ", "\n"])), function (_ref4) {
  var filled = _ref4.filled;
  return filled && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      & path {\n        fill: #fff;\n      }\n    "])));
});